export default "__VITE_ASSET__tFH$LRvY__"